import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

/**
 * Fires when the Worker Type pop-up is viewed (Dual Model States).
 * Event: dental_portal:office_signup:worker_type_popup_viewed
 */
export function fireWorkerTypePopupViewed(): void {
  PosthogService.getInstance().track('dental_portal:office_signup:worker_type_popup_viewed', {
    design_date: REDESIGN_SIGNUP_DESIGN_DATE,
  });
}
